export default "__VITE_ASSET__CxlATm_6__"